import { scrollToSection } from "@/components/Reveal";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Products", href: "#products" },
  { label: "Process", href: "#process" },
  { label: "Logistics", href: "#markets" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => (
  <footer className="relative border-t border-[#2E7FE0]/15 bg-[#030B1C] py-16" data-testid="site-footer">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-12 mb-16">
        <div>
          <div className="mb-6">
            <span className="bg-white rounded-lg px-5 py-3.5 inline-flex shadow-[0_0_30px_rgba(46,127,224,0.25)]">
              <img src="/nexgen-logo-horizontal.png" alt="NexGen Sourcing Private Limited" className="h-9 w-auto" data-testid="footer-logo" />
            </span>
          </div>
          <p className="text-[#A1B0C8] text-sm max-w-sm leading-relaxed">
            Your sourcing and export partner in India — connecting global buyers to verified
            Indian manufacturers across textiles, food, home and industrial products.
          </p>
        </div>

        <nav className="grid grid-cols-2 gap-x-16 gap-y-4" data-testid="footer-nav">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollToSection(l.href)}
              className="text-left font-mono2 text-xs uppercase tracking-[0.25em] text-[#A1B0C8] hover:text-white transition-colors duration-300"
              data-testid={`footer-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="text-sm text-[#A1B0C8] space-y-2" data-testid="footer-contact">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#2E7FE0] mb-4">Contact</p>
          <p>Kolkata, West Bengal, India</p>
          <p>sales@nxgensourcing.com</p>
          <p>www.nxgensourcing.com</p>
        </div>
      </div>

      <div className="border-t border-[#2E7FE0]/10 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#A1B0C8]/60" data-testid="footer-copyright">
          © 2026 NexGen Sourcing Private Limited. All rights reserved.
        </p>
        <p className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#A1B0C8]/60">
          IEC · GST
        </p>
      </div>
    </div>
  </footer>
);
